import script from "./GeneticIdInputView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeneticIdInputView.vue?vue&type=script&setup=true&lang=ts"

import "./GeneticIdInputView.vue?vue&type=style&index=0&id=4d357b4c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src839921157/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d357b4c"]])

export default __exports__